// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import * as ToolbarMenuUtils from './ToolbarMenuUtils';

export default ToolbarMenuUtils;
